import Navbar from './components/Navbar';
import TickerRibbon from './components/TickerRibbon';
import Hero from './components/Hero';
import FeedSection from './components/FeedSection';
import HotSection from './components/HotSection';
import ChannelSection from './components/ChannelSection';
import TimelineSection from './components/TimelineSection';
import FeatureSection from './components/FeatureSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CtaBand from './components/CtaBand';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import { faqItems } from '@/mocks/faq';

const siteUrl = 'https://qnalo.cn/';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '看料站',
  alternateName: '看料站 · 全网热点实时速报',
  url: siteUrl,
  description:
    '看料站实时更新追踪，紧盯全网动态，第一时间同步最新爆料与事件进展，提供滚动更新的即时内容速报与全网热榜。',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '看料站',
  url: siteUrl,
  description: '以实时更新追踪为核心的全网热点资讯速报站。',
  email: 'hello@kanliaozhan.example',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <Navbar />
      <TickerRibbon />
      <main>
        <Hero />
        <FeedSection />
        <HotSection />
        <ChannelSection />
        <TimelineSection />
        <FeatureSection />
        <FaqSection />
        <AboutSection />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}